export const stripDiacritics = (s) => (s ?? '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '');